import { Action } from '@ngrx/store';
import { autenticar } from 'src/app/models/SicarMap/Inicio/autenticar.model';


export enum RegUsrActionTypes {
  REGISTRO = '[Auth] REGISTRO',
  REGISTRO_SUCCESS = '[Auth] REGISTRO Success',
  REGISTRO_FAILURE = '[Auth] REGISTRO Failure',
}

export class ExecRegistro implements Action {
  readonly type = RegUsrActionTypes.REGISTRO;
  constructor(public Credenciales: autenticar) {}
}

export class RegistroSuccess implements Action {
  readonly type = RegUsrActionTypes.REGISTRO_SUCCESS;
  constructor(public TokenActivo: any) {}
}

export class RegistroFailure implements Action {
  readonly type = RegUsrActionTypes.REGISTRO_FAILURE;
  constructor(public payload: any) {}
}


export type RegUsrAcciones =
  | ExecRegistro
  | RegistroSuccess
  | RegistroFailure;
